"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newISymmetricSwap = exports.ABI = void 0;
exports.ABI = [
    {
        inputs: [],
        name: "paused",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "from", type: "address" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "swap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
function newISymmetricSwap(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newISymmetricSwap = newISymmetricSwap;
//# sourceMappingURL=ISymmetricSwap.js.map